import { theme } from "@chakra-ui/core";

const customTheme = {
  ...theme,
  fonts: {
    heading: "AvertaPE, sans-serif",
    body: "system-ui, sans-serif",
    mono: "Menlo, monospace",
  },
  colors: {
    ...theme.colors,
    gray: {
      50: "#F9FAFB",
      100: "#F4F5F7",
      200: "#E6E7EB",
      300: "#D2D6DC",
      400: "#9FA6B2",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#252F3F",
      900: "#161E2E",
    },
    green: {
      50: "#F2FAF7",
      100: "#DEF7EC",
      200: "#BDF0DA",
      300: "#84E1BC",
      400: "#31C48D",
      500: "#109F6E",
      600: "#057A55",
      700: "#056C4E",
      800: "#02543E",
      900: "#004737",
    },
    red: {
      50: "#FCF2F2",
      100: "#FDE8E8",
      200: "#FBD5D5",
      300: "#F7B4B4",
      400: "#F98180",
      500: "#F05252",
      600: "#E02325",
      700: "#C81E1F",
      800: "#9B1C1C",
      900: "#771D1D",
    },
    yellow: {
      50: "#FDFDEA",
      100: "#FDF6B2",
      200: "#FCE86A",
      300: "#FACA15",
      400: "#E3A007",
      500: "#C27804",
      600: "#9F580B",
      700: "#8E4B10",
      800: "#723C14",
      900: "#633112",
    },
    brand: {
      50: "#f9f8f6",
      100: "#f8f4e3",
      200: "#f6e6a6",
      300: "#f2d35c",
      400: "#ebb32c",
      500: "#e49017",
      600: "#c96a0b",
      700: "#a5540c",
      800: "#7c4011",
      900: "#613113",
    },
    // other brand color palette variant
    // brand: {
    //   50: '#faf8f6',
    //   100: '#faf4e1',
    //   200: '#fae1a7',
    //   300: '#f8c767',
    //   400: '#f79e35',
    //   500: '#f6771c',
    //   600: '#e8500d',
    //   700: '#ce3f0e',
    //   800: '#a93215',
    //   900: '#822815',
    // },
  },
  shadows: {
    ...theme.shadows,
    xs: "0 0 0 1px rgba(0,0,0,.05)",
    leftWhiteBlur: "-20px 0px 8px -5px rgba(255,255,255,1)",
    rightWhiteBlur: "20px 0px 8px -5px rgba(255,255,255,1)",
  },
  sizes: {
    ...theme.sizes,
    "7xl": "80rem",
  },
};

export default customTheme;
